import type { FC } from 'react'
import React from 'react'
import { Redirect as RouterRedirect } from 'react-router-dom'
import type { IRedirectProps } from './interfaces'

const Redirect: FC<IRedirectProps> = ({ url }) => <RouterRedirect to={url} />

export default Redirect
